var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85714 7.57143C4.85714 7.72321 4.91964 7.86607 5.02679 7.97322L9.02679 11.9732C9.13393 12.0804 9.27679 12.1429 9.42857 12.1429C9.74107 12.1429 10 11.8839 10 11.5714V3.57143C10 3.25893 9.74107 3 9.42857 3C9.27679 3 9.13393 3.0625 9.02679 3.16964L5.02679 7.16964C4.91964 7.27679 4.85714 7.41964 4.85714 7.57143Z",
    fill: "#5A8FC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/ArrowLeftIcon.0c9ef026db177171860d942a8e77eadc.svg";
export { ForwardRef as ReactComponent };